<script lang="ts">
  import * as noUiSlider from 'nouislider';
  import { onMount } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { fade } from 'svelte/transition';
  import { getAppConfig } from '../../../../common/config/app-config';
  import { getStr, globalCurrencyTag, isDirectionRTL } from '../../../../common/util';
  import '../../../product-listing-search/components/filter/nouiSlider.css';
  import ExtraButton from '../../components/ExtraButton.svelte';
  import ExtraSnackBar from '../../components/ExtraSnackBar.svelte';
  import Text from '../../components/Text.svelte';
  import { OPTION_RESPONSE_FIELDS, getProductsByUrlFromAlgoliaAsync } from '../../services/algolia';
  import { closeSnackbar, showSnackbar } from '../../store/snackbar_store';

  export let priceDiff;
  export let dataLoaded;
  export let currentCategoryURLLink;
  export let facetsStatsMinPrice;

  // let snackbarWithoutClose: Snackbar;
  const rtl = isDirectionRTL();
  const { countryCode, encodedContextPath } = getAppConfig();
  let theSlider;
  let maxPriceInput;
  let minPriceInput;
  let sliderApi: noUiSlider.API;
  let showSliderBox = false;
  let disableButton: boolean = false;
  const minPriceFS = facetsStatsMinPrice;
  const maxPriceFS = priceDiff * 4 + minPriceFS;
  let productCounts: number;

  onMount(() => {
    initSliderRange();
    return () => sliderApi.destroy();
  });

  function getParamsForSlider() {
    let step = 0.1;
    let startMin = 0;
    let startMax = maxPriceFS;
    let rangeMin = 0;
    let rangeMax = maxPriceFS;

    if (countryCode === 'SA') {
      step = 1;
      startMin = 0;
      startMax = maxPriceFS;
      rangeMin = 0;
      rangeMax = maxPriceFS;
    }
    return { startMin, startMax, rangeMin, rangeMax, step };
  }
  var { startMin, startMax, rangeMin, rangeMax, step } = getParamsForSlider();

  function initSliderRange() {
    sliderApi = noUiSlider.create(theSlider, {
      connect: true,
      behaviour: 'tap',
      start: [startMin, startMax],
      step: step,
      range: {
        min: [rangeMin],
        max: [rangeMax],
      },
      direction: (rtl && 'rtl') || 'ltr',
      tooltips: {
        // tooltips are output only, so only a "to" is needed
        to: function (numericValue) {
          const tooltipPrice = getStr('jood.price.with.currency', [globalCurrencyTag, numericValue.toFixed(0)]);
          return tooltipPrice;
        },
      },
    });
    sliderApi.on('update', onUpdateSlider);
  }

  export function updateSliderRange(priceDiff, minPrice) {
    disableButton = false;
    rangeMax = priceDiff * 4 + minPrice;
    theSlider.noUiSlider.updateOptions({
      start: [startMin, rangeMax],
      range: {
        min: [startMin],
        max: [rangeMax],
      },
    });
  }

  // fires on dragMove
  function onUpdateSlider(values) {
    disableButton = false;
    // snackbarWithoutClose.close();
    closeSnackbar();
    minPriceInput.value = parseFloat(values[0]);
    rangeMin = minPriceInput.value;
    maxPriceInput.value = parseFloat(values[1]);
    rangeMax = maxPriceInput.value;
    minPriceInput.addEventListener('change', function () {
      sliderApi.setHandle(0, this.value);
    });
    maxPriceInput.addEventListener('change', function () {
      sliderApi.setHandle(1, parseFloat(this.value));
    });
  }

  function collapseSlider() {
    showSliderBox = !showSliderBox;
  }

  function getaAgoliaUrl(minPrice, maxPrice) {
    const url = composeCategoryUrl(currentCategoryURLLink, minPrice, maxPrice);
    return url;
  }
  function getFirstTilePrice(priceDiff, minPrice) {
    return priceDiff + minPrice;
  }
  function getSecondTilePrice(priceDiff, minPrice) {
    return priceDiff + minPrice + 1 + '-' + (priceDiff * 2 + minPrice);
  }
  function getThirdTilePrice(priceDiff, minPrice) {
    return priceDiff * 2 + minPrice + 1 + '-' + (priceDiff * 3 + minPrice);
  }
  function getFourthTilePrice(priceDiff, minPrice) {
    return priceDiff * 3 + minPrice + 1 + '-' + (priceDiff * 4 + minPrice);
  }

  function onSubmit(event, minPrice, maxPrice) {
    disableButton = true;
    getProductsByUrlFromAlgoliaAsync(getaAgoliaUrl(minPrice, maxPrice), OPTION_RESPONSE_FIELDS(['nbHits']))
      .then((res: any) => {
        productCounts = res?.hits?.length;
        if (productCounts > 0) {
          disableButton = false;
          const url = composeCategoryUrl(currentCategoryURLLink, minPrice, maxPrice);
          window.location.assign(url);
        } else {
          event.preventDefault();
          disableButton = true;
          // snackbarWithoutClose.open();
          showSnackbar($_(getStr('extra.category.budget.component.cantfindproduct')), 'info', 10000, false);
        }
      })
      .then(() => Object.assign({}, { className: 'no-divider' }))
      .catch(() => (dataLoaded = false))
      .finally(() => (dataLoaded = true));
  }

  function composeCategoryUrl(categoryUrl: string, minPrice, maxPrice) {
    if (categoryUrl?.length === 0) {
      return '';
    }
    categoryUrl = decodeURIComponent(categoryUrl).replace(/:price:\d+-\d+/g, '');
    const isAbsoluteUrl = categoryUrl.startsWith('http');
    const dummyBase = document.location.origin;
    const url = new URL(categoryUrl, dummyBase);
    let newQ = `:price:${minPrice}-${maxPrice}`;
    if (url.searchParams.has('q')) {
      newQ = url.searchParams.get('q') + newQ;
    } else {
      newQ = ':relevance' + newQ;
    }
    newQ = newQ.replaceAll(' ', '%20');
    url.searchParams.set('q', newQ);

    if (isAbsoluteUrl) {
      return url.href;
    }
    const urlParam = encodedContextPath + url.href.replace(dummyBase, '');
    return urlParam;
  }
</script>

<div class="right-content">
  <div class="category-price-card-wrapper">
    <div class="category-price-card-container">
      {#if !dataLoaded}
        <div class="skeleton-loader-container">
          <div class="skeleton-item" in:fade></div>
          <div class="skeleton-item" in:fade></div>
          <div class="skeleton-item" in:fade></div>
          <div class="skeleton-item" in:fade></div>
          <div class="skeleton-item" in:fade></div>
        </div>
      {:else}
        <a href={getaAgoliaUrl(0, priceDiff + facetsStatsMinPrice)}>
          <div class="category-price-card">
            <div class="category-price">
              &lt;
              <span
                ><Text
                  key="jood.price.with.currency"
                  args={[globalCurrencyTag, getFirstTilePrice(priceDiff, facetsStatsMinPrice)]}
                /></span
              >
            </div>
            <div class="category-link">
              <Text key="extra.category.budget.component.viewproducts" />
            </div>
          </div>
        </a>

        <a href={getaAgoliaUrl(priceDiff + facetsStatsMinPrice + 1, priceDiff * 2 + facetsStatsMinPrice)}>
          <div class="category-price-card">
            <div class="category-price">
              <span
                ><Text
                  key="jood.price.with.currency"
                  args={[globalCurrencyTag, getSecondTilePrice(priceDiff, facetsStatsMinPrice)]}
                /></span
              >
            </div>
            <div class="category-link">
              <Text key="extra.category.budget.component.viewproducts" />
            </div>
          </div>
        </a>
        <a href={getaAgoliaUrl(priceDiff * 2 + facetsStatsMinPrice + 1, priceDiff * 3 + facetsStatsMinPrice)}>
          <div class="category-price-card">
            <div class="category-price">
              <span
                ><Text
                  key="jood.price.with.currency"
                  args={[globalCurrencyTag, getThirdTilePrice(priceDiff, facetsStatsMinPrice)]}
                /></span
              >
            </div>
            <div class="category-link">
              <Text key="extra.category.budget.component.viewproducts" />
            </div>
          </div>
        </a>
        <a href={getaAgoliaUrl(priceDiff * 3 + facetsStatsMinPrice + 1, priceDiff * 4 + facetsStatsMinPrice)}>
          <div class="category-price-card">
            <div class="category-price">
              <span
                ><Text
                  key="jood.price.with.currency"
                  args={[globalCurrencyTag, getFourthTilePrice(priceDiff, facetsStatsMinPrice)]}
                /></span
              >
            </div>
            <div class="category-link">
              <Text key="extra.category.budget.component.viewproducts" />
            </div>
          </div>
        </a>

        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class={`category-price-card collapse-desktop ${showSliderBox ? 'show-slider' : ''}`}
          on:click={collapseSlider}
        >
          <div class="category-text">
            <Text key="extra.category.budget.component.setmybudget" />
          </div>
          <div class="category-icon">
            <span class="c_icon_new c_icon_new--ar_back ar_back"></span>
          </div>
        </div>
      {/if}
    </div>
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class={`category-collapse-mobile ${showSliderBox ? 'show-slider' : ''}`} on:click={collapseSlider}>
    <span><Text key="extra.category.budget.component.ownbudget" /></span>
    <span class={`c_icon_new  c_icon_new--chevron${showSliderBox ? '_up ' : '_down'}`}></span>
  </div>

  <div class={`category-price-slider-container ${showSliderBox ? '' : 'd-none'}`}>
    <div class="facet-price">
      <div class="price-slider-v2" id="slider-no-overlap" bind:this={theSlider}></div>
    </div>
    <div class="range-info">
      <div class="range-info-box-wrapper">
        <div class="range-info-box lb">
          <span class="supp">
            <Text key="extra.category.budget.component.min" />
          </span>
          <span class="val min-value">
            <span>{@html globalCurrencyTag}</span>
            <input class="range-info-input" type="number" bind:this={minPriceInput} min={startMin} />
          </span>
        </div>
        <div class="range-info-box rb">
          <span class="supp">
            <Text key="extra.category.budget.component.max" />
          </span>
          <span class="val max-value">
            <span>{@html globalCurrencyTag}</span>
            <input class="range-info-input" type="number" bind:this={maxPriceInput} max={startMax} />
          </span>
        </div>
      </div>
      <div class="range-info-button-box">
        <!-- <Button
          class={`range-info-button ${disableButton ? 'disabled' : ''}`}
          on:click={() => onSubmit(event, rangeMin, rangeMax)}
          disabled={disableButton}
        >
          <Text key="extra.category.budget.component.apply" />
        </Button> -->
        <ExtraButton
          customClass={`range-info-button ${disableButton ? 'disabled' : ''}`}
          variant="solid"
          color="primary"
          size="large"
          disabled={disableButton}
          on:click={() => onSubmit(event, rangeMin, rangeMax)}
        >
          {getStr('extra.category.budget.component.apply')}
        </ExtraButton>
      </div>
    </div>
  </div>
</div>
<!-- <Snackbar
    labelText={$_(getStr("extra.category.budget.component.cantfindproduct"))}
    class="demo-success"
    bind:this={snackbarWithoutClose}
    timeoutMs={10000}
>
    <Label></Label>
</Snackbar> -->
<ExtraSnackBar />

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .right-content {
    .category-price-card-wrapper {
      display: flex;
      overflow: auto;
      @include desktop-max-width {
        display: flex;
        overflow: auto;
      }
      &::-webkit-scrollbar {
        display: none;
      }
      .category-price-card-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 10px;
        gap: 8px;
        .skeleton-loader-container {
          display: flex;
          gap: 8px;
          .skeleton-item {
            width: 168px;
            height: 78px;
            border-radius: 12px;
            @include desktop-max-width {
              height: 140px;
              height: 40px;
            }
          }
        }

        .category-price-card {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 16px 12px;
          justify-content: flex-start;
          min-width: 168px;
          max-width: max-content;
          height: 78px;
          flex-shrink: 0;
          border-radius: 12px;
          background: $secondary-pink-01;
          color: $primary-white;
          cursor: pointer;
          user-select: none;
          @include desktop-max-width {
            width: max-content;
            gap: 4px;
            padding: 8px 12px;
            height: auto;
          }
          .category-price {
            font-size: 18px;
            line-height: 20px;
            font-weight: 400;
            @include desktop-max-width {
              font-size: 16px;
            }
            span {
              font-weight: 700;
            }
          }
          .category-link {
            color: $primary-white;
            font-size: 14px;
            font-weight: 500;
            line-height: 16px;
            text-decoration-line: underline;
            @include desktop-max-width {
              font-size: 10px;
              line-height: 11px;
            }
          }
        }

        .category-price-card {
          &.collapse-desktop {
            display: flex;
            flex-direction: row;
            @include desktop-max-width {
              display: none;
            }
            .category-text {
              font-size: 20px;
              font-weight: 400;
              line-height: 22px;
              letter-spacing: 0px;
              width: 106px;
              text-align: left;
            }
            .category-icon {
              margin: auto;
              span {
                height: 30px;
                width: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                background: $primary-white;
                border-radius: 50%;
                color: $secondary-pink-01;
                font-weight: 800;
                font-size: 14px;
                transform: rotate(90deg);
              }
            }
          }
        }

        .category-price-card {
          &.collapse-desktop.show-slider {
            background-color: $primary-black;
            .category-icon {
              span {
                color: $primary-black;
                transform: rotate(-90deg);
              }
            }
          }
        }

        :global {
          .mdc-button {
            padding: 0px !important;
            min-height: 78px !important;
            border-color: transparent !important;
          }
          .mdc-button__ripple {
            display: none;
          }
        }
      }
    }
    .category-collapse-mobile {
      display: none;
      @include desktop-max-width {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 20px;
        gap: 4px;
      }
      span {
        color: $icon-only-icon-blue;
        font-size: 16px;
        font-weight: 500;
        line-height: 18px;
      }
      .c_icon_new--chevron_down {
        font-size: 24px;
        width: 24px;
        height: 24px;
        transform: rotate(-90deg);
      }
      .c_icon_new--chevron_up {
        font-size: 24px;
        width: 24px;
        height: 24px;
      }
    }
  }

  .range-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 60px;
    margin-bottom: 15px;
    gap: 16px;
    @include desktop-max-width {
      margin-top: 25px;
      flex-direction: column;
    }
    .range-info-box-wrapper {
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: 16px;
      .range-info-box {
        display: flex;
        flex-direction: column;
        flex: 1 1 50%;

        .supp {
          font-size: 14px;
          font-weight: 400;
          line-height: 14px;
          color: $neutral-dark-03;
          padding-bottom: 8px;
          @include desktop-max-width {
            font-size: 14px;
          }
        }

        .min-value,
        .max-value {
          display: flex;
          width: 100%;
          height: 64px;
          padding: 8px 16px;
          align-items: center;
          gap: 16px;
          border-radius: 12px;
          border: 1px solid $neutral-dark-03;
          @include desktop-max-width {
            height: 48px;
          }
          span {
            color: $neutral-dark-01;
            width: 33px;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 16px;
            @include desktop-max-width {
              font-size: 14px;
              line-height: 16px;
            }
          }
          .range-info-input {
            height: 54px;
            border: none;
            font-size: 18px;
            color: $neutral-dark-01;
            font-weight: 400;
            line-height: 16px;
            outline: none;
            @include desktop-max-width {
              font-size: 14px;
              line-height: 16px;
              height: 46px;
            }
          }
        }
      }
    }
    .range-info-button-box {
      margin-top: 20px;
      :global {
        .range-info-button {
          display: flex;
          width: 207px;
          padding: 18px !important;
          justify-content: center;
          align-items: center;
          background: $primary-blue;
          color: $primary-white;
          border-radius: 109px;
          font-size: 24px !important;
          font-weight: 700 !important;
          line-height: 28px !important;
          height: 68px;
          letter-spacing: 0px !important;
          @include desktop-max-width {
            font-size: 16px !important;
            height: 48px;
            width: 100%;
          }
        }
        &.disabled {
          background: $neutral-dark-04 !important;
          opacity: 0.5;
        }
        .mdc-button__ripple {
          display: none;
        }
      }
    }
  }

  .category-price-slider-container {
    width: 872px;
    padding-top: 140px;
    @include desktop-max-width {
      width: 100%;
      padding-top: 60px;
    }
    :global {
      .price-slider-v2.noUi-horizontal {
        height: 8px;
        border: none;
        margin-right: 30px;
        border-radius: 20px;
        background: $secondary-gray-02;

        .noUi-connect {
          border: 0.1rem solid $primary-blue;
          background-color: $primary-blue;
        }
        .noUi-handle {
          cursor: pointer;
          width: 18px;
          height: 18px;
          right: -17px;
          top: -8px;

          z-index: 0;
          background: $primary-blue;
          border: 0.01rem solid rgba($neutral-dark-02, 0.1);
          border-radius: 50%;
          box-shadow:
            0 0.3rem 0.3rem rgba($black, 0.05),
            0 0.2rem 0.2rem rgb($black, 0.1),
            0 0.3rem 0.1rem rgb($black, 0.05);

          &::before,
          &::after {
            display: none;
          }
        }
      }

      .noUi-tooltip {
        display: block;
        position: absolute;
        background: transparent;
        padding: 5px;
        text-align: center;
        white-space: nowrap;
      }
      .noUi-horizontal .noUi-tooltip {
        border: none;
        font-size: 18px;
        font-weight: 400;
        line-height: 16px;
        -webkit-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        left: 50%;
        bottom: 120%;
        color: $neutral-dark-01;
        @include desktop-max-width {
          font-size: 14px;
        }
      }

      .noUi-handle-lower .noUi-tooltip {
        bottom: 110%;
        @include desktop-max-width {
          left: 30%;
        }
      }
      .noUi-handle-upper .noUi-tooltip {
        bottom: 150%;
      }
      .noUi-handle {
        border: 1px solid #d9d9d9;
        border-radius: 3px;
        background: #fff;
        cursor: default;
        box-shadow:
          inset 0 0 1px #fff,
          inset 0 1px 7px #ebebeb,
          0 3px 6px -3px #bbb;
      }

      #slider-no-overlap .noUi-handle-lower {
        background: $primary-blue;
        right: -31.5px;
        width: 31.5px;
        height: 31.5px;
        top: -11px;
        @include desktop-max-width {
          right: -24px;
          width: 24px;
          height: 24px;
          top: -8px;
        }
      }
      .noUi-handle-lower .noUi-touch-area:after {
        content: '||';
        position: absolute;
        font-size: 18px;
        line-height: 0.8;
        color: #fff;
        transition: all 0.2s;
        left: 10px;
        top: 8px;
        font-weight: 500;
        @include desktop-max-width {
          font-size: 14px;
          left: 7px;
          top: 6px;
        }
      }
      #slider-no-overlap .noUi-handle-upper {
        background: $primary-blue;
        right: -34px;
        width: 34px;
        height: 34px;
        top: -13px;
        box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.12);
        @include desktop-max-width {
          right: -24px;
          width: 24px;
          height: 24px;
          top: -8px;
        }
      }
      .noUi-handle-upper .noUi-touch-area:after {
        content: '||';
        position: absolute;
        font-size: 20px;
        line-height: 0.8;
        color: #fff;
        transition: all 0.2s;
        left: 11px;
        top: 9px;
        font-weight: 500;
        @include desktop-max-width {
          font-size: 14px;
          left: 7px;
          top: 6px;
        }
      }
    }

    .facet-price {
      .noUi-target {
        box-sizing: border-box;
        margin: 1rem 1rem 2rem 0;
        touch-action: none;
        user-select: none;
        position: relative;
      }
      .noUi-base,
      .noUi-connects {
        height: 100%;
        position: relative;
        width: 100%;
      }
      /* Wrapper for all connect elements.
            */
      .noUi-connect,
      .noUi-origin {
        position: absolute;
        right: 0;
        top: 0;
        transform-origin: 0 0;
        transform-style: flat;
        will-change: transform;
        z-index: 0;
      }
      .noUi-connect {
        height: 100%;
        width: 100%;
      }
      .noUi-origin {
        height: 10%;
        width: 10%;
      }
      /* Give origins 0 height/width so they don't interfere with clicking the
            * connect elements.
            */
      .noUi-horizontal .noUi-origin {
        height: 0;
      }
      .noUi-handle {
        backface-visibility: hidden;
        position: absolute;
      }
      .noUi-touch-area {
        height: 100%;
        width: 100%;
      }
      .noUi-state-tap .noUi-connect,
      .noUi-state-tap .noUi-origin {
        transition: transform 0.3s;
      }
      .noUi-state-drag {
        cursor: inherit;
      }

      /* Slider size and handle placement;
            */
      .noUi-horizontal {
        height: 0.2rem;
      }
      .noUi-horizontal .noUi-handle {
        cursor: pointer;
        height: 2.8rem;
        right: -17px;
        top: -1.4rem;
        width: 2.9rem;
        z-index: 0;
      }
      /* Styling;
            * Giving the connect element a border radius causes issues with using transform: scale
            */
      .noUi-target {
        background: #dbe0e4;
        border-radius: 4px;
        box-shadow:
          inset 0 1px 1px #f0f0f0,
          0 3px 6px -5px #bbb;
      }
      .noUi-connects {
        border-radius: 3px;
      }
      .noUi-connect {
        background: $primary-blue;
        border: 0.1rem solid $primary-blue;
      }
    }
  }

  /*rtl:end:ignore*/
</style>
